import { ProjectType } from "#app/enums/projectEnums"

export type UnreadMessage = {
  _id: string;
  msgUnread: number;
  teUnread: number;
}

type UnreadBadgeProps = {
  type: string,
  unreads: UnreadMessage[]
}

export function UnreadBadge({ type, unreads }: UnreadBadgeProps) {
  function getTotal() {
    if(!unreads || unreads.length === 0) {
      return 12
    }
    var count = 0
    if(type == 'inbox') {
      const thisUnread = unreads.filter((unread) => unread._id == ProjectType.maintenance || unread._id == ProjectType.violation || unread._id == ProjectType.arcReview)
      if(thisUnread.length) {
        for (let i = 0; i < thisUnread.length; i++) {
          count += thisUnread[i].teUnread
          count += thisUnread[i].msgUnread
        }
      }
    }
    if(type == 'violations') {
      const thisUnread = unreads.find((unread) => unread._id == ProjectType.violation)
      if(thisUnread) {
        count = thisUnread?.teUnread + thisUnread?.msgUnread
      }
    }
    if(type == 'maintenance') {
      const thisUnread = unreads.find((unread) => unread._id == ProjectType.maintenance)
      if(thisUnread) {
        count = thisUnread?.teUnread + thisUnread?.msgUnread
      }
    }
    if(type == 'arc-reviews') {
      const thisUnread = unreads.find((unread) => unread._id == ProjectType.arcReview)
      if(thisUnread) {
        count = thisUnread?.teUnread + thisUnread?.msgUnread
      }
    }
    if(type == 'activations') {
      const thisUnread = unreads.filter((unread) => unread._id == ProjectType.homeowner || unread._id == ProjectType.property)
      if(thisUnread.length) {
        for (let i = 0; i < thisUnread.length; i++) {
          count += thisUnread[i].teUnread
          count += thisUnread[i].msgUnread
        }
      }
    }
    if(type == 'reminders') {
      const thisUnread = unreads[0]
      if(thisUnread) {
        count = thisUnread?.teUnread + thisUnread?.msgUnread
      }
    }
    return count
  }
  
  return (
    <>
      {getTotal() > 0 && (
        <div className="bg-danger w-7 h-7 border-white border rounded-full relative z-0 items-center justify-center flex">
        <div className="bg-danger w-5 h-5 border-white border rounded-full relative z-0">
          <div className="absolute inset-0 flex justify-center items-center z-10">
            <p className="text-sm font-bold text-white">{getTotal()}</p>
          </div>
        </div>
      </div>
      )}
    </>
  )
}